// Core
import React, { useEffect } from 'react';

// Libraries
import { useTranslation } from 'react-i18next';

// Layout
import { Tag, TagType } from '../../layout/elements/Tag';

// Component
import { EquipmentStatusTagProps } from './EquipmentStatusTag.types';

function EquipmentStatusTag({
  className,
  status,
  testId,
  text,
}: EquipmentStatusTagProps): JSX.Element {
  const { i18n } = useTranslation();

  // UseEffect to re-render on language change
  useEffect((): void => {
    // Force update component when language changes
  }, [i18n.language]);

  const convertTagType = (equipmentStatus: EquipmentStatusTagProps['status']): TagType => {
    const mapStatus: Record<string, TagType> = {
      fault: TagType.critical,
      running: TagType.success,
      starting: TagType.warning,
      stopped: TagType.neutral,
    };
    return mapStatus[equipmentStatus];
  };

  return (
    <Tag
      testId={testId}
      className={className}
      type={convertTagType(status)}
      text={text}
    />
  );
}

export { EquipmentStatusTag };
